import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    FormGroup,
    Label,
    Input,
    FormFeedback,
    Row,
    Col
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../../assets/svg/move.svg';
import moreIcon from '../../../assets/svg/more.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import xIcon from '../../../assets/svg/x.svg';



import moment from 'moment';
import { API_ENDPOINT, getAgeLimit, translateAgeLimitMessage } from '../../../constants';
import ErrorModal_v2 from '../../../components/errorModal_v2';
import CustomSelectWithSearch from '../../../components/forms/fields/customSelectWithSearch';
import Checkbox from '../../../components/forms/fields/checkbox';
import DatePicker from '../../../components/forms/fields/datePicker';
import TimePickerV2 from '../../../components/forms/fields/timepicker_v2';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import EventMeetingsModal from '../../../components/eventMeetingsModal';
import SelectWithCheckbox from '../../../components/forms/fields/selectWithCheckbox';
import { isStringAValidNumber } from '../../../components/TwoFactorAuthModal';
import ErrorModal from '../../../components/errorModal';

import striptags from 'striptags';
import DoctorListComponent from '../../../components/forms/fields/doctorListComponent';
import InfoModal from '../../../components/infoModal';
import PatientModal from './patientModal';
import ScheduleControl from './scheduleControl';
import UpdateEventTemplate from './updateEventTemplate';

function isTimeValidString(timeString) {
    let valid = false;
    if (timeString?.length === 5) {
        const [hours, minutes] = timeString.split(":").map((x) => parseInt(x, 10));
        if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
            valid = true;
        }
    }


    return valid;
}


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
function truncateString(str) {
    if (str.length > 210) {
        return str.substring(0, 210) + '...';
    }
    return str;
}

class HandleTemplateModal extends React.Component {

    constructor(props) {
        super(props);

        this.player = React.createRef();
        this.state = {
            ...props.initialData,

        }
    }

    stopAnimation = () => {
        this.player.current.play();
    };



    setInitialData = () => {
        // this.fetchAvailabilityTemplates();
        // this.setInitialSelectOptions();
        // this.fetchWebBookingForms();
        // this.getClinicians();
    }
    getClinicians = () => {
        const clinicId = this.props.selectedClinic;
        if (!clinicId) return;

        this.setState({ clinicians: [] }, () => {
            fetch(API_ENDPOINT + `/data/calendar/doctors/${clinicId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.clinicians?.length) {
                    this.setState({ clinicians: result.clinicians }, () => {
                        if (!this.state.doctorId && this.props.doctorId && this.state.clinicians?.find(el => el._id === this.props.doctorId)) {
                            this.setState({ doctorId: this.props.doctorId });
                        }
                    });
                }
            })
        });
    }
    fetchAvailabilityTemplates = () => {
        this.setState({ availabilityTemplates: [] }, () => {
            fetch(API_ENDPOINT + '/data/availability-templates/data/fetch', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    userId: this.props.uData?._id,
                    groupId: this.props.selectedGroup,
                    clinicId: this.props.selectedClinic
                })
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.items?.length) {
                    this.setState({ availabilityTemplates: result.items })
                }
            })
        })
    }
    setInitialSelectOptions = () => {
        let selectOptions = this.state.selectOptions;
        for (let i = 1; i <= 20; i++) {
            selectOptions.instances.push(i)
        }
        for (let i = 0; i <= 90; i += 5) {
            selectOptions.gap.push(i)
        }
        this.setState({ selectOptions })
    }
    fetchWebBookingForms = () => {
        if (this.state.doctorId) {
            this.setState({ webBookingForms: [] }, () => {
                fetch(API_ENDPOINT + '/working-hours/web-booking-forms', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        doctor: this.state.doctorId,
                        group: this.props.selectedGroup,
                        clinic: this.props.selectedClinic
                    })
                }).then(parseJSON).then(({ result, status }) => {
                    if (result?.length) {
                        this.setState({ webBookingForms: result })
                    }
                })
            })
        }


    }




    componentDidMount() {
        this.setInitialData();

        if (this.props.isOpen) {
            let data = this.props.isOpen;
            if (!data?.date || !data?.endDate || !data?.startTime || !data?.endTime) {
                let initialTime = this.generateInitialTime();
                data = {
                    ...initialTime,
                    ...data
                }
            }
            this.setState({ data: data, isOpen: this.props.isOpen })
        }

    }
    componentDidUpdate(prevProps, prevState) {
        // if (prevProps.isOpen !== this.props.isOpen) {
        //     let data = this.props.isOpen;
        //     if (!data?.date || !data?.endDate || !data?.startTime || !data?.endTime) {
        //         let initialTime = this.generateInitialTime();
        //         data = {
        //             ...initialTime,
        //             ...data
        //         }
        //     }

        //     this.setState({ data: data })
        // }

    }
    componentWillUnmount() {

    }

    toggle = (callback = null) => {
        if (this.props.toggle) {
            this.props.toggle(callback);
        }

    }
    formatDate = (date, format) => {
        if (!date || !format) return '';
        let dateString = date?.split(' ')?.[0];
        let timeString = date?.split(' ')?.[1];

        let DD = dateString?.split('/')[1];
        let MM = dateString?.split('/')[0];
        let YYYY = dateString?.split('/')[2];
        let HH = timeString?.split(':')[0];
        let mm = timeString?.split(':')[1];

        let formattedDate = format
            .replace('DD', DD)
            .replace('MM', MM)
            .replace('YYYY', YYYY)
            .replace('HH', HH)
            .replace('mm', mm);

        return formattedDate;

    }


    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        let groupData = this.props?.uData?.clinicGroups?.[selectedGroupIdx];

        return groupData;
    }
    generateInitialTime = () => {
        let tsNow = Math.floor(new Date().getTime() / 1000);
        const interval = 10 * 60;
        const ts = Math.ceil(tsNow / interval) * interval;

        let date = moment.unix(ts).format(this.props.dateFormat);
        let startTime = moment.unix(ts).format('HH:mm');
        let endTime = moment.unix(ts + 60 * 5).format('HH:mm');

        let data = {
            date,
            endDate: date,
            startTime,
            endTime,
            title: ''
        }

        return data;
    }


    setData = (data, callback) => {
        this.setState({ data }, () => {
            if (this.state.data?.patient) {
                this.setState({ scheduleControl: { ...this.state.data } })
            }
            if (callback) {
                callback();
            }
        })
    }




    render() {
        const isOpen = this.state.isOpen ? true : false;
        if (!this.state.data) return null;

        const groupData = this.getGroupData();
        const enterprise = groupData?.enterprise;
        const eventMeetings = groupData?.eventMeetings ?? false;

        const patientModal = this.state.patientModal;
        const scheduleControl = this.state.scheduleControl;
        const updateEventTemplate = this.state.updateEventTemplate;


        return (
            <>

                <Modal isOpen={isOpen} centered>
                    <ModalHeader toggle={() => this.toggle()}
                        close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggle()}>&times;</button>}>
                        {'Select option'.translate(this.props.lang)}
                    </ModalHeader>

                    <ModalBody>
                        <div className='schedule-modal-body-wrap'>
                            <Button color='primary'
                                onClick={() => {
                                    let data = { ...this.state.data };
                                    let patientModal = {
                                        date: data.date,
                                        doctor: data?.doctor,
                                        startTime: data.startTime,
                                        endTime: data.endTime,
                                        templateData: { ...data }
                                    }
                                    this.setState({ isOpen: false, patientModal })
                                }}
                            >
                                {'Schedule Appointment'.translate(this.props.lang)}
                            </Button>
                            <Button color='primary'
                                onClick={() => {
                                    let updateEventTemplate = { ...this.state.data }
                                    this.setState({ isOpen: false, updateEventTemplate });

                                    // this.setState({ updateEventTemplate, updateEventTemplatePreModal: !this.state.updateEventTemplatePreModal })

                                }}
                            >
                                {'Edit'.translate(this.props.lang)}
                            </Button>

                        </div>

                    </ModalBody>
                </Modal>

                {
                    patientModal ?
                        <PatientModal
                            {...this.props}
                            isOpen={patientModal}
                            toggle={(notToggle = false) => this.setState({ patientModal: false }, () => {
                                if (!notToggle) {
                                    this.toggle();
                                }
                            })}
                            setData={(data, callback) => this.setData(data, callback)}
                        />
                        :
                        null
                }
                {
                    scheduleControl ?
                        <ScheduleControl
                            {...this.props}
                            isOpen={scheduleControl}
                            toggle={(notToggle = false) => this.setState({ scheduleControl: false }, () => {
                                if (!notToggle) {
                                    this.toggle();
                                }
                            })}
                            findPatient={(data, callback) => {
                                // console.log('findPatient', data);
                                this.setState({ patientModal: data, scheduleControl: false }, () => {

                                    if (callback) {
                                        callback();
                                    }
                                })
                            }}
                        />
                        :
                        null
                }
                {
                    updateEventTemplate ?
                        <UpdateEventTemplate
                            {...this.props}
                            isOpen={updateEventTemplate}
                            toggle={(notToggle = false, fetchItems = false) => this.setState({ updateEventTemplate: false }, () => {
                                if (fetchItems && this.props.fetchItems) {
                                    this.props.fetchItems();
                                }
                                if (!notToggle) {
                                    this.toggle();
                                }
                            })}
                            bookVisitFromTemplate={() => {
                                let data = { ...this.state.data };
                                let patientModal = {
                                    date: data.date,
                                    doctor: data?.doctor,
                                    startTime: data.startTime,
                                    endTime: data.endTime,
                                    templateData: { ...data }
                                }
                                this.setState({ updateEventTemplate: false, patientModal })
                            }}

                        />
                        :
                        null
                }



            </>


        )
    }
}

export default HandleTemplateModal;